export default "__VITE_ASSET__DDrYnl5x__"